var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-footer"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"footer-info"},[_c('div',{staticClass:"record"},[_c('img',{staticClass:"icon",attrs:{"src":require("../assets/record_icon.png"),"alt":"record icon"}}),_vm._v(" 备案号:滇公网安备53010202000946号 ")]),_c('div',[_vm._v("滇备案号:ICP备17009526号")]),_c('div',[_vm._v("技术支持:云南青才信息科技有限公司")])])])])
}]

export { render, staticRenderFns }